import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import tooltip from '@/mixins/components/tooltip';

export default Vue.component('dynamic-page', {
  template: require('./template.html'),
  name: 'dynamic-page',
  mixins: [dynamicSetup],
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
    siteType() {
      const dynamicData = this.currentSite.dynamic && this.currentSite.dynamic[this.activeSiteType];
      return !dynamicData ? { page: {} } : dynamicData;
    },
    pagesDisabled() {
      return this.siteType.page && (this.siteType.page.modal || this.siteType.page.external);
    },
    allPages() {
      const range = [{ name: 'No Page', _id: null }];
      const pages = this.siteType.pages || [];
      _.forEach(pages, (page) => {
        range.push({
          _id: page._id,
          name: page.name,
          url: page.url,
        });
      });
      const search = new RegExp(this.searchPages, 'gi');
      return _.filter(range, p => p.name.match(search));
    },
  },
  components: {
    tooltip,
  },
  data() {
    return {
      initialEdits: {
        modal: false,
        external: false,
        dynamicId: null,
        groupPageId: null,
        pageLink: '',
        groupPageLink: '',
        externalLink: '',
      },
      searchPages: '',
      pageLink: '',
      groupPageLink: '',
      externalLink: '',
      modal: false,
      external: false,
      dynamicId: null,
      groupPageId: null,
      showPages: false,
      showGroupPages: false,
      showExternals: false,
    };
  },
  props: [
    'content',
    'dynamic-data',
  ],
  watch: {
    content(content) {
      if (content === 'page') {
        this.setInitialValues();
      }
    },
    showGroupPages(open) {
      if (open) {
        this.searchPages = '';
      }
    },
    showPages(open) {
      if (open) {
        this.searchPages = '';
      }
    },
  },
  methods: {
    setInitialValues() {
      // page link
      const _id = this.siteType.page ? this.siteType.page.dynamicId : false;
      const page = _.find(this.allPages, p => p._id === _id);
      const groupPageId = this.siteType.page ? this.siteType.page.groupPageId : false;
      const groupPage = _.find(this.allPages, p => p._id === groupPageId);
      const externalLink = this.siteType.page ? this.siteType.page.externalLink : false;
      // set local data
      this.pageLink = page ? page.name : 'No Page';
      this.groupPageLink = groupPage ? groupPage.name : 'No Page';
      this.modal = this.siteType.page && this.siteType.page.modal;
      this.external = this.siteType.page && this.siteType.page.external;
      this.externalLink = externalLink;
      this.dynamicId = _id;
      this.groupPageId = groupPageId;
      // set initials
      this.initialEdits.pageLink = this.pageLink;
      this.initialEdits.groupPageLink = this.groupPageLink;
      this.initialEdits.modal = this.modal;
      this.initialEdits.external = this.external;
      this.initialEdits.externalLink = externalLink;
      this.initialEdits.dynamicId = _id;
      this.initialEdits.groupPageId = groupPageId;
    },
    updatePageLink(page, pageType, typeLink) {
      if (this.noDynamicData(this.activeSiteType)) {
        this.dynamicSetup(this.activeSiteType);
      }
      this[typeLink] = page.name;
      this[pageType] = page._id;
      const typeData = this.currentSite.dynamic[this.activeSiteType];
      if (!typeData.page) {
        this.$store.dispatch('setDropletVal', {
          drp: typeData,
          key: 'page',
          val: {
            dynamicId: null,
            groupPageId: null,
            modal: false,
          },
        });
      }
      this.$store.dispatch('setDropletVal', {
        drp: typeData.page,
        key: pageType,
        val: page._id,
      });
      this.showPages = false;
      this.showGroupPages = false;
    },
    updateExternal(external) {
      if (this.noDynamicData(this.activeSiteType)) {
        this.dynamicSetup(this.activeSiteType);
      }
      this.externalLink = external;
      const typeData = this.currentSite.dynamic[this.activeSiteType];
      if (!typeData.page) {
        this.$store.dispatch('setDropletVal', {
          drp: typeData,
          key: 'page',
          val: {
            dynamicId: null,
            groupPageId: null,
            external: false,
          },
        });
      }
      this.$store.dispatch('setDropletVal', {
        drp: typeData.page,
        key: 'externalLink',
        val: external,
      });
      this.showExternals = false;
    },
    setModal() {
      if (this.noDynamicData(this.activeSiteType)) {
        this.dynamicSetup(this.activeSiteType);
      }
      const typeData = this.currentSite.dynamic[this.activeSiteType];
      if (!typeData.page) {
        this.$store.dispatch('setDropletVal', {
          drp: typeData,
          key: 'page',
          val: {
            dynamicId: null,
            groupPageId: null,
            modal: false,
          },
        });
      }
      this.$store.dispatch('setDropletVal', {
        drp: typeData.page,
        key: 'modal',
        val: this.modal,
      });
    },
    setExternal() {
      if (this.noDynamicData(this.activeSiteType)) {
        this.dynamicSetup(this.activeSiteType);
      }
      const typeData = this.currentSite.dynamic[this.activeSiteType];
      if (!typeData.page) {
        this.$store.dispatch('setDropletVal', {
          drp: typeData,
          key: 'page',
          val: {
            dynamicId: null,
            groupPageId: null,
            external: false,
          },
        });
      }
      this.$store.dispatch('setDropletVal', {
        drp: typeData.page,
        key: 'external',
        val: this.external,
      });
    },
    cancelChanges() {
      this.modal = this.initialEdits.modal;
      this.external = this.initialEdits.external;
      this.dynamicId = this.initialEdits.dynamicId;
      this.pageLink = this.initialEdits.pageLink;
      this.groupPageId = this.initialEdits.groupPageId;
      this.groupPageLink = this.initialEdits.groupPageLink;
      this.setModal();
      this.updatePageLink({
        _id: this.dynamicId,
        name: this.pageLink,
      }, 'dynamicId', 'pageLink');
      this.updatePageLink({
        _id: this.groupPageId,
        name: this.groupPageLink,
      }, 'groupPageId', 'groupPageLink');
      this.$emit('set-content', null);
    },
    async saveChanges() {
      if (!this.noPageChanges()) {
        this.$emit('set-loading', true);
        const notif = {
          id: this.guid(),
          type: 'success',
          message: 'Changes Successfully Saved!',
        };
        try {
          if (this.noDynamicData(this.activeSiteType)) {
            this.dynamicSetup(this.activeSiteType);
          }
          await this._SEND([{
            name: 'updateSiteAttr',
            payload: {
              siteId: this.currentSite._id,
              attr: 'dynamic',
              value: this.currentSite.dynamic,
            },
          }]);
          this.$log.debug('successfully updated dynamic page type');
          // reset initials
          this.initialEdits.pageLink = this.pageLink;
          this.initialEdits.groupPageLink = this.groupPageLink;
          this.initialEdits.modal = this.modal;
          this.initialEdits.external = this.external;
          this.initialEdits.externalLink = this.externalLink;
          this.initialEdits.dynamicId = this.dynamicId;
          this.$emit('set-content', null);
        } catch (e) {
          this.$log.error('error: ', e);
          notif.type = 'error';
          notif.message = `${e.message || e}. This has been reported.`;
          await this._reportError({
            error: e,
            fn: 'items - update dynamic page',
          });
        } finally {
          this.$emit('set-loading', false);
          this.$store.dispatch('addNotification', notif);
        }
      }
    },
    lowerCase(string) {
      return _.lowerCase(string);
    },
    noPageChanges() {
      return this.modal === this.initialEdits.modal &&
        this.external === this.initialEdits.external &&
        this.externalLink === this.initialEdits.externalLink &&
        this.dynamicId === this.initialEdits.dynamicId &&
        this.groupPageId === this.initialEdits.groupPageId;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/dynamic-page/index.js